var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpired(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "98px",
    height: "98px",
    viewBox: "0 0 98 98",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Survey---Expipred",
    transform: "translate(-711.000000, -334.000000)",
    fill: "#1E87F0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(498.000000, 334.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_expired_1241404",
    transform: "translate(213.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "48.87 17.19 40.87 17.19 40.87 41.15 25.5 41.15 25.5 49.15 48.87 49.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.64,51.76 C89.7978793,39.0326324 86.2380571,26.0010466 77.9092667,16.1383097 C69.5804764,6.2755728 57.3290013,0.583831437 44.42,0.58 C27.8729947,0.573621793 12.7321642,9.88449673 5.27176795,24.6542602 C-2.18862831,39.4240238 -0.697373773,57.1359773 9.1275656,70.4504053 C18.952505,83.7648333 35.4370055,90.4130196 51.75,87.64 C57.8379381,95.4082891 67.8543666,98.9774103 77.4829019,96.8093206 C87.1114373,94.641231 94.6313766,87.1233869 96.8021493,77.4954561 C98.9729221,67.8675253 95.4065923,57.8501026 87.64,51.76 Z M44.42,80.26 C24.6261146,80.26 8.58,64.2138854 8.58,44.42 C8.58,24.6261146 24.6261146,8.58 44.42,8.58 C64.2138854,8.58 80.26,24.6261146 80.26,44.42 C80.26,45.5 80.2,46.58 80.1,47.65 C70.8737517,44.4984478 60.6582033,46.8700969 53.7641501,53.7641501 C46.8700969,60.6582033 44.4984478,70.8737517 47.65,80.1 C46.58,80.2 45.5,80.26 44.42,80.26 Z M71.84,89.42 C62.1376606,89.4144779 54.2763204,81.5456774 54.2800013,71.8433371 C54.2836821,62.1409969 62.1509906,54.2781635 71.8533314,54.2800032 C81.5556722,54.2818428 89.4199984,62.147659 89.42,71.85 C89.4089783,81.5490741 81.5490741,89.4089783 71.85,89.42 L71.84,89.42 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 67.85,
    y: 58.97,
    width: 8,
    height: 18.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 67.85,
    y: 79.97,
    width: 8,
    height: 5.75
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpired);
export default __webpack_public_path__ + "static/media/expired.ff965e1e48dbb07755057bc4daec643e.svg";
export { ForwardRef as ReactComponent };